module.exports = __webpack_public_path__ + "img/LOGO_Blue@3x.1262a26d.png";